module.exports = __webpack_public_path__ + "static/switch-316dc1841a46c1f5979dbabf9fefbea5.jpg";